import React, { useState } from 'react'
import { Row, Col, Typography, Card, Button, Tag } from "antd";

import Prospects from "../../../assets/images/Prospects.svg";

import { useHistory } from "react-router-dom";
import TitleComponent from "./Title";
import styled from "styled-components";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import Recommendations from "components/Recommendations/Recommendations"
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import CatalogueCard from "./CatalogueCard";
import ProductCard from "./ProductCard";
import HistoryCard from "./HistoryCard";
import ProspectCard from "./ProspectCard";
const AllProductsCard = styled.div`
  .card {
    margin-right: 1rem;
    min-height: 2em;
    margin-top: 0.5rem;
    padding: 1rem;
    border-radius: 0.5rem;
    &:hover {
      background: #f5fcfb;
      cursor: pointer;
    }
    @media (max-width: 400px) {
      padding: 0rem;
    }
  }
  cursor: pointer;
  .icon {
    /* margin-top:1em; */
  }
`;
const CreateCatalougueCard = styled.div`
  .card {
    margin-right: 1rem;
    min-height: 22em;
    margin-top: 0.5rem;
    padding: 1rem;
    border-radius: 0.5rem;
    &:hover {
      background: #fffcf7;
      cursor: pointer;
    }
    @media (max-width: 400px) {
      padding: 0rem;
    }
  }
  cursor: pointer;
  .icon {
    /* margin-top:1em; */
  }
`;
const SeeCatalougueCard = styled.div`
  .card {
    margin-right: 1rem;
    min-height: 22em;
    margin-top: 0.5rem;
    padding: 1rem;
    border-radius: 0.5rem;
    &:hover {
      background: #fafcf5;
      cursor: pointer;
    }
    @media (max-width: 400px) {
      padding: 0rem;
    }
  }
  cursor: pointer;
  .icon {
    /* margin-top:1em; */
  }
`;

//Recommendations for you



const { Title, Text } = Typography;
export default function Dashboard() {
  const history = useHistory();
  
  return (
    <div >
      <Row>
        <Col
          lg={{ span: 22, offset: 0 }}
          xl={{ span: 22, offset: 0 }}
          md={{ span: 22, offset: 1 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Text type="secondary" style={{fontSize:'16px',}}>
          Manage all your products, create custom catalogues for buyers and prospects in minutes!
          </Text>
        </Col>
      </Row>
      <Row >

        <Col
          span={16}
        >
          <Row>

            <Col
              xs={24}
              sm={24}
              md={{ span: 24 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
            {/* casl starts here */}
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) => <ProductCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
            
            </Col>

            <Col
              xs={24}
              sm={24}
              md={{ span: 24 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
            {/* casl starts here */}
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) => <CatalogueCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
          </Col>

            <Col
              xs={24}
              sm={24}
              md={{ span: 24 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
           {/* casl starts here */}
           <Can
            I={PERMISSIONS.view_catalogues.slug}
            a={PERMISSIONS.view_catalogues.permissionType}
            passThrough
          >
            {(allowed) => <HistoryCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
            </Col>

            <Col
              xs={24}
              sm={24}
              md={{ span: 24 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}

            >

                <ProspectCard allowed={true} />
             
            </Col>
          </Row>
        </Col>

        <Col span={8}>

          <Recommendations/>

        </Col>

      </Row>
    </div>
  );
}




